import { isPlaybookWorkspaceTag } from "@common/utils/playbook-workspace-tag";

export function tagLabel(name: string): string {
  return isPlaybookWorkspaceTag(name) ? "Playbook" : name.trim();
}
